<div
  class="filters"
  fxLayout="column"
  fxLayoutAlign="center center"
  fxLayout.gt-xs="row"
  fxLayoutAlign.gt-xs="space-between center"
>
  <mat-form-field
    floatLabel="always"
    class="course-search"
  >
    <input matInput (input)="search($event.target.value)" />
    <mat-icon matPrefix>search</mat-icon>
  </mat-form-field>
</div>
